import { render, staticRenderFns } from "./HealthCheck25PsaThyroid.vue?vue&type=template&id=075daaaa&scoped=true&"
import script from "./HealthCheck25PsaThyroid.vue?vue&type=script&lang=js&"
export * from "./HealthCheck25PsaThyroid.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck25PsaThyroid.vue?vue&type=style&index=0&id=075daaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075daaaa",
  null
  
)

export default component.exports